import { IApplicationState } from '../../types/redux';
import { getNewbuildingByIdSelector } from './getNewbuildingByIdSelector';

export const getNewbuildingSalesLeaderByIdSelector =
  (newbuildingId: number) =>
  (state: IApplicationState): boolean => {
    const nb = getNewbuildingByIdSelector(newbuildingId)(state);

    return nb.isSalesLeader;
  };
